import React from 'react';
import { bool, shape, string } from 'prop-types';

const InrowCultivation = ({
  className = '',
  notUseClass = false,
  style = { color: '#9A6412' },
}) => (
  <svg className={notUseClass ? '' : className} style={style} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M19.9639 13.2676L21.9277 12.1338L22.9277 13.8662L16 17.8662L15 16.1338L17.9639 14.4219V9H12.9639V13.2676L14.9287 12.1338L15.9277 13.8662L9 17.8662L8 16.1338L10.9639 14.4219V9H5.96387V13.2676L7.92871 12.1338L8.92773 13.8662L2 17.8662L1 16.1338L3.96387 14.4219V7H19.9639V13.2676Z" fill="currentColor" />
  </svg>
);

InrowCultivation.propTypes = {
  className: string,
  notUseClass: bool,
  style: shape({}),
};

export default InrowCultivation;
